import { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Play } from 'lucide-react';

interface StartData {
  label?: string;
}

export const StartNode = memo(({ data }: NodeProps<StartData>) => {
  return (
    <div className="bg-neutral-900 border-2 border-green-500/40 rounded-lg p-4 min-w-[200px] shadow-lg">
      <div className="flex items-center gap-2 mb-2">
        <Play className="w-5 h-5 text-green-400" />
        <span className="font-bold text-white">Início do Fluxo</span>
      </div>

      <div className="text-brand-ivory/70 text-sm">
        Este é o ponto de partida do fluxo
      </div>

      <Handle type="source" position={Position.Bottom} className="w-3 h-3 !bg-green-500" />
    </div>
  );
});

StartNode.displayName = 'StartNode';
